var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1398_52117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 5.23451C9.55 6.09609 9.02248 6.57936 8.87406 7.15502H10.9403C11.6187 7.15502 12.1468 7.71861 12.15 8.33513C12.1517 8.6995 11.9967 9.09175 11.7551 9.33445L11.7529 9.33668C11.9527 9.81071 11.9202 10.4749 11.5638 10.9509C11.7402 11.4769 11.5624 12.123 11.2311 12.4694C11.3184 12.8269 11.2766 13.1311 11.1062 13.376C10.6916 13.9716 9.66408 13.98 8.79517 13.98L8.73738 13.98C7.75655 13.9797 6.95382 13.6225 6.30882 13.3356C5.98469 13.1914 5.56089 13.0129 5.23934 13.007C5.1065 13.0045 5 12.8961 5 12.7633V8.42105C5 8.35605 5.02604 8.29367 5.07227 8.24797C5.87693 7.45286 6.22293 6.61105 6.88246 5.9504C7.18317 5.64913 7.29253 5.19405 7.39826 4.75396C7.48859 4.37816 7.67753 3.58002 8.0875 3.58002C8.575 3.58002 9.55 3.74252 9.55 5.23451Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51094 7.80502H2.88594C2.6167 7.80502 2.39844 8.02328 2.39844 8.29252V13.1675C2.39844 13.4368 2.6167 13.655 2.88594 13.655H4.51094C4.78018 13.655 4.99844 13.4368 4.99844 13.1675V8.29252C4.99844 8.02328 4.78018 7.80502 4.51094 7.80502Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4219 1.46271L12.1189 3.15976L14.3817 0.897022",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1398_52117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPractice);
export default __webpack_public_path__ + "static/media/ic_practice.cea98f44a01c96da04d0fcaddebf8c53.svg";
export { ForwardRef as ReactComponent };